import { PlaylistPreParseDecryptStage } from '@streamLoader/PlaylistDecrypt/PlaylistParsers/PlaylistPreParseDecrypt/PlaylistPreParseDecryptStage';

export class V1PreParseURLRestore extends PlaylistPreParseDecryptStage {
  constructor() {
    super();
  }

  public restorePlaylist(data: string): string {
    const lines: string[] = data.split('\n');
    let fileValue: string | null = null;

    for (let i: number = 0; i < lines.length; i++) {
      const trimmedLine: string = lines[i].trim();

      if (trimmedLine.startsWith('#EXT-X-MOUFLON:FILE:')) {
        fileValue = trimmedLine.substring('#EXT-X-MOUFLON:FILE:'.length).trim();
        continue;
      }

      if (fileValue !== null && trimmedLine.includes('media.mp4')) {
        lines[i] = trimmedLine.replace('media.mp4', `xxx_${fileValue}`);
        fileValue = null;
      }
    }

    return lines.join('\n');
  }
}
